module.exports = __webpack_public_path__ + "img/symbol_9.fe5142c3.png";